<div class="filters-wrapper flex flex-col lg:flex-row mb-[32px] gap-4" id="dashboard__container">
  <form [formGroup]="filtersForm" class="flex-1 w-full lg:max-w-[calc(40%-1rem)]" id="dashboard__form-container">
    <div class="input-icon" id="dashboard__text-filter-label">
      <ed-input-field>
        <ed-label>
          {{ "dashboard.location_performance.textFilterLabel" | transloco }}
        </ed-label>
        <input formControlName="textFilter" edInput />
      </ed-input-field>
      <mat-icon svgIcon="search" class="search-icon"> </mat-icon>
    </div>
  </form>
  <div class="dropdown-container flex-1 w-full lg:max-w-[calc(20%-1rem)]">
    <label for=""> {{ "dashboard.location_performance.productSelectionLabel" | transloco }}</label>
    <er-multi-select
      bindLabel="label"
      bindValue="value"
      [closeOnSelect]="false"
      [searchable]="true"
      [items]="items"
      [ngModel]="selectedColumns"
      (ngModelChange)="changeColumnVisibility($event)"
      [useTranslations]="true"
      [clearable]="false"
      [minOneRequired]="true"
      id="dashboard__selected-columns"
    />
  </div>
</div>
